import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';
import { translate, Interpolate } from 'react-i18next';

const exampleRequest = `curl https://mise.se/TestAPI/api/searchCompanyName?name=marknadsinformation&from=1&to=3 \\
  -H "Authorization: Basic TWlzZUFwaTpNaXNlQXBpIzIwMTgwNA=="`

const exampleResponse = `[
  {
    "personal_identity_no": "19700101-7566",
    "status": "N",
    ...
  },
  {
    ...
  },
  {
    ...
  }
]`;

const PaginationSection = (props) => (

  <section className="method row" id="pagination">
    <div className="method__text method__text col-lg-6">
      <h1 className="h2">{props.t('title')}</h1>
      <hr />
      <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />
      <h5>{props.t('common:params')}</h5>
      <div className="table-responsive">
        <table className="table table-striped">
          <tbody>
            <tr>
              <th>
                from<br />
                <small>{props.t('common:optional')}</small>
              </th>
              <td>{props.t('params.from')}</td>
            </tr>
            <tr>
              <th>
                to<br />
                <small>{props.t('common:optional')}</small>
              </th>
              <td>{props.t('params.to')}</td>
            </tr>               
          </tbody>
        </table>
      </div>
    </div>
    <div className="method__code col-lg-6">
      <small>{props.t('common:exampleRequest')}</small>
      <SyntaxHighlighter language='bash' style={sunburst}>
        { exampleRequest }          
      </SyntaxHighlighter>
      <small>{props.t('common:exampleResponse')}</small>
      <SyntaxHighlighter language='json' style={sunburst}>
        { exampleResponse }        
      </SyntaxHighlighter>
    </div>
  </section>

);
export default translate(['PaginationSection', 'common'])(PaginationSection);



// WEBPACK FOOTER //
// ./src/components/sections/PaginationSection.jsx